module.exports = __webpack_public_path__ + "static/media/email.86945ad1.svg";